/// <reference types="./reply.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function reply() {
  return $svg.square(
    14,
    "<path d=\"M6.41683 11.6667L0.583496 7.00004L6.41683 2.33337V5.25004C9.63858 5.25004 12.2502 7.86162 12.2502 11.0834C12.2502 11.2426 12.2443 11.4001 12.2315 11.5559C11.3518 9.88754 9.60066 8.75004 7.5835 8.75004H6.41683V11.6667Z\" fill=\"currentColor\"/>",
  );
}
